import React from 'react';
import { Input } from 'antd';
import { NumericFormat } from 'react-number-format';

const CurrencyInput = ({ value, onChange, maxLength = 25, placeholder, ...rest }) => (
    <NumericFormat
        value={value}
        onValueChange={(values) => {
            onChange(values.value); // pass raw number back to form
        }}
        thousandSeparator=","
        decimalScale={2}
        allowNegative={true}
        prefix="$ "
        customInput={Input}
        maxLength={maxLength}
        placeholder={placeholder}
        {...rest}
    />
);

export default CurrencyInput;
